<ng-container *ngIf="data && data.length > 0">
	<div class="content-container clients_page d-block">
		<header>
			<h1 i18n="@@dashboard.monthly_invoices">Monthly Invoices</h1>	
		</header>

		<div class="table_block">
			<div class="filters_block">
				<svg class="search_icon start-100 end-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
					<path d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z" stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
				<input type="text" class="filters_search pl-2 pr-5" (keyup)="searchInvoice($event.target.value)" placeholder="Search Invoice" name="data-table__search--input" i18n-placeholder="@@input.search_here" #searchInput>
				<div class="filters_btn_wrap">
					<div class="d-flex align-center"> </div>
				</div>
			</div>
			<table class="marketing_table clients_item list-view">
				<thead>
					<tr>
						<th i18n="@@invoice.month">Month</th>
                        <th i18n="@@invoice.total_amount">Total Amount</th>
						<th i18n="@@ts.action" class="action-col">Action</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngIf="data && data.length > 0; noRecord">
						<tr *ngFor="let row of data | paginate: paginator; index as i">
							<td data-label="Phone">
								<span>{{ row.month_label }}</span>
							</td>
                            <td data-label="Total">
								<span>{{ row.total_amount }}</span>
							</td>
							<td data-label="Action" class="action-col">
								<button type="button" class="btn-sm text-white" (click)="downloadMonthlyInvoice(row.month)">
                                    <span i18n="@@download">Download</span>
                                </button>
							</td>
						</tr>
					</ng-container>
					<ng-template #noRecord>
						<tr>
							<td [attr.colspan]="3" class="text-center font-weight-normal"> 
								<ng-container *ngIf="loading; else noRecord" i18n="@@common.loading">Loading...</ng-container> 
								<ng-template #noRecord>
									<ng-container i18n="@@common.no_record_found">No record found.</ng-container> 
								</ng-template>
							</td>
						</tr>
					</ng-template>
				</tbody>
			</table>
			<ng-container>
				<div class="pagination_wrapper">
					<div class="showing_results">
						<div class="select_wrapper">
							<ng-container i18n="@@show">Show</ng-container>
							<select class="select-link tab-links-select" id="tab-links-select" nice-select [(ngModel)]="paginator.itemsPerPage" (change)="onChangeItemsPerPage($event, p)">
								<option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
							</select>
							<ng-container i18n="@@items">items</ng-container>
						</div>
						<div class="results_list" *ngIf="paginator?.from || paginator?.to">
							<ng-container i18n="@@showing_from">Showing from</ng-container> {{ paginator?.from }}
							<ng-container i18n="@@to">to</ng-container> {{ paginator?.to }} 
							<ng-container i18n="@@of">of</ng-container> {{ paginator?.totalItems }} 
							<ng-container i18n="@@items">items</ng-container>
						</div>
					</div>
					<nav pagination-template #p="paginationApi" [id]="paginator.id" (pageChange)="getPage($event)"
						aria-label="...">
						<ul class="pagination justify-content-center">
							<li class="page-item" [class.disabled]="p.isFirstPage()">
								<a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
									<svg width="7.5" height="13.5">
										<path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
									</svg>
								</a>
							</li>

							<li *ngFor="let page of p.pages" class="page-item" [class.active]="p.getCurrent() === page.value">
								<a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)" class="page-link">
									<span>{{ page.label }}</span>
								</a>
								<a *ngIf="p.getCurrent() === page.value" class="page-link">{{page.label}} <span class="sr-only">(current)</span></a>
							</li>

							<li class="page-item" [class.disabled]="p.isLastPage()">
								<a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
									<svg width="7.5" height="13.5">
										<path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
									</svg>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</ng-container>
		</div>
	</div>
</ng-container>